import { render, staticRenderFns } from "./ViewAssessment.vue?vue&type=template&id=29b07d58&scoped=true"
import script from "./ViewAssessment.vue?vue&type=script&lang=js"
export * from "./ViewAssessment.vue?vue&type=script&lang=js"
import style0 from "./ViewAssessment.vue?vue&type=style&index=0&id=29b07d58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b07d58",
  null
  
)

export default component.exports